import { useState } from 'react'

import { SoftwareSchema } from 'openapi'
import { resizeImgUrl } from 'utils/resizeImgUrl'
import { Dialog, DialogContent, DialogTrigger } from 'shadcdn/ui/dialog'

export function SoftwareScreenshots(props: { software: SoftwareSchema }) {
  const { software } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <div className="bg-gray-1200 w-full max-h-96 flex-shrink-0 cursor-pointer">
          <img
            src={resizeImgUrl(software.cover, '1200px')}
            alt={`${software.name} cover`}
            className="w-auto h-full max-h-96 object-contain mx-auto shadow-md"
          />
        </div>
      </DialogTrigger>
      <DialogContent className="border-0 max-w-full p-0 w-auto inline-block">
        <img
          src={software.cover!}
          alt={`${software.name} cover full size`}
          className="block max-w-full max-h-[80vh] object-contain mx-auto"
        />
      </DialogContent>
    </Dialog>
  )
}
